
import { en } from './en';
import { ru } from './ru';
import { tr } from './tr';
import { es } from './es';
import { pt } from './pt';
import { de } from './de';  // Add the new German translation

export const translations = {
  en,
  ru,
  tr,
  es,
  pt,
  de  // Include 'de' in the translations object
};

export type Language = keyof typeof translations;
export type TranslationKeys = typeof en;

